import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getTextsAdmin, updateText } from "../../features/texts/textSlice";
import { useNavigate } from "react-router-dom";
import ReactQuill from "react-quill";
import ButtonPrimary from "../../components/style-components/ButtonPrimary";
import "react-quill/dist/quill.snow.css";

function AdminTexts() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { admin_texts } = useSelector((state) => state.texts);
  const [filteredTexts, setFilteredTexts] = useState(admin_texts || []);

  const [value, setValue] = useState("");
  const [valueEng, setValueEng] = useState("");
  const [selectedText, setSelectedText] = useState(null);

  useEffect(() => {
    dispatch(getTextsAdmin());
  }, [dispatch]);

  useEffect(() => {
    setFilteredTexts(admin_texts);
    if (admin_texts && admin_texts.length > 0 && !selectedText) {
      setSelectedText(admin_texts[0]);
      setValue(admin_texts[0].value);
      setValueEng(admin_texts[0].value_eng || "");
    }
  }, [admin_texts]);

  const { user } = useSelector((state) => state.auth);

  useEffect(() => {
    if (!user || user.type !== "admin") {
      navigate("/");
    }
  }, [user, navigate]);

  const handleTextClick = (text_tag) => {
    const text = admin_texts.find((t) => t.tag === text_tag);
    setSelectedText(text);
    setValue(text.value);
    setValueEng(text.value_eng || "");
  };

  const handleSave = () => {
    if (selectedText) {
      const updatedText = {
        id: selectedText._id, // Changed _id to id to match the backend
        tag: selectedText.tag,
        value: value,
        value_eng: valueEng,
        category: selectedText.category,
        complex: selectedText.complex,
      };
      dispatch(updateText(updatedText));
    }
  }

  return (
    <>
      <div className="admin-texts-header padding-10-bottom">
        <ButtonPrimary text="Add new text" type="primary" onClick={() => {}} />
      </div>
      <div className="admin-edit-texts">
        <div className="text-list">
          {filteredTexts && filteredTexts.length > 0 ? (
            filteredTexts.map((text) => (
              // NOTE: Changed text._id to text.id to match the find in handleTextClick
              <div
                className="text-entry"
                key={text.id}
                onClick={() => handleTextClick(text.tag)}
              >
                {text.tag}
              </div>
            ))
          ) : (
            <div>No texts available.</div>
          )}
        </div>

        {selectedText && (
          <div className="text-edit-section">
            <p className="bold padding-10-bottom">{selectedText.tag}</p>
            <div className="padding-10-bottom"></div>
            {selectedText.complex ?
                <div className="complex-inputs flex column gap-10">
                  LV
                  <ReactQuill
                    placeholder="Teksta saturs latviski"
                    className="my-quill"
                    value={value}
                    onChange={setValue}
                  />
                  EN
                  <ReactQuill
                    placeholder="Teksta saturs angliski"
                    className="my-quill"
                    value={valueEng}
                    onChange={setValueEng}
                  />
                </div>
            :
              <div className="complex-inputs flex column gap-10">
                <textarea 
                  placeholder="Teksta saturs latviski"
                  value={value}
                  onChange={(e) => setValue(e.target.value)}
                  className="simple-text-input"
                  name="simple-text-input-lv" 
                  id="text-simple-lv" 
                />
                <textarea 
                  placeholder="Teksta saturs angliski"
                  value={valueEng}
                  onChange={(e) => setValueEng(e.target.value)}
                  className="simple-text-input"
                  name="simple-text-input-en" 
                  id="text-simple-en" 
                />
              </div>
            }
            
            
            
            <div className="padding-10-top"></div>
            <ButtonPrimary text="Saglabāt" type="primary" onClick={() => handleSave()} />
            {/* <div className="flex gap-10">
                <ButtonPrimary 
                    text={selectedText ? "Atjaunināt tekstu" : "Pievienot jaunu"} 
                    onClick={handleAddText} 
                />
                {selectedText && <ButtonPrimary text="Atcelt rediģēšanu" onClick={handleNewText} />}
            </div> */}
          </div>
        )}
      </div>
      <div className="padding-40-bottom"></div>
    </>
  );
}

export default AdminTexts;
